import { IPerformanceTeamReviewActionPayload } from '../interfaces/create-performance-team-review.interface';

export class PerformanceTeamReviewCommand {
    name: string;
    start_date: string;
    due_date: string;
    type: {
        id: string;
    };
    period_under_review: {
        id: string;
    };
    goal_setting_period: {
        id: string;
    };
    team: {
        id: string;
    };
    user_ids: string[];
    source_team_id: string;
    context: number;

    constructor(query: IPerformanceTeamReviewActionPayload) {
        this.name = query.name;
        this.start_date = query.startDate;
        this.due_date = query.dueDate;
        this.type = { id: query.type.id };
        this.period_under_review = { id: query.periodUnderReview.id };
        this.goal_setting_period = { id: query.goalSettingPeriod.id };
        this.team = { id: query.team.id };
        this.user_ids = query.userIds;
        this.context = query.context;
    }
}
